import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';
import PaymentCardFields, { CARD_BILLING_POSTCODE_SELECTOR, CARD_FIELDSET_SELECTOR } from '../PaymentCardFields';
import PaymentMethodSelector from '../PaymentMethodSelector';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

const CLICK_EVENT = 'click';

class CheckoutComponent extends FormComponent {
    set error(error) {
        this._error = error;
        if (this._error) {
            this.setErrorHandler(this._error);
        }

        if (this.shouldRerenderOnError) {
            this.render();
            this.initiatePaymentCardFields();
        }
    }

    get error() {
        return this._error;
    }

    markup(value, rowData, titleMarkup) {

        if (rowData) {
            this.rowData = rowData;
        }
        return `
            <div class="lta-checkout-component">
                <div class="lta-checkout-component__form-wrapper">
                    <div class="lta-checkout-component__title u-border-botton u-w-100 u-hidden md:u-block">${titleMarkup}</div>
                    <form id="payment" class="js-lta-payment-checkout lta-checkout-component__form u-w-100 md:u-pr-2" data-provider="lta_payment">
                        <div class="p-checkout__error-container ${this.error ? '' : 'u-hidden'}">
                            <div class="u-mb-2 xl:u-mb-5">
                                <div class="lta-snackbar lta-snackbar--alert u-mb-0 data-alert">
                                    <p class="lta-snackbar__label title" aria-label="The course that you have selected is now fully booked." onclick="">${this.error}</p>
                                    <button type="button" class="lta-btn lta-btn--sm lta-btn--inverse lta-btn--block p-checkout__error-container-btn">Close</button>
                                    <div class="lta-snackbar__icon">
                                        <svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor" alt="alert" aria-hidden="true">
                                            <use xlink:href="/static/images/icons/lta-icons.svg#alert"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        ${rowData?.isDiscount
                            ? `
                                <div class="p-checkout-component__discount-code-container u-border-top u-pt-3">
                                    <div class="p-checkout-component__discount-code-valid-container u-mb-2 u-hidden">
                                        <p class="lta-text-input__label">Discount code</p>
                                        <div class="p-checkout-component__discount-code-valid u-pt-1 u-pl-3 u-pb-3 u-pr-1 xl:u-pr-2 u-bg-background-green u-rounded u-vstack">
                                            <button type="button" class="lta-btn lta-btn--default lta-btn--link lta-btn--icon lta-btn--icon-before p-checkout-component__discount-code-valid-remove">
                                                <svg class="lta-icon js-lta-text-input--btn-icon u-mr-0 " width="1.5em" height="1.5em" style="color:;" fill="" alt="close" aria-hidden="true" ||="" currentcolor=""><use xlink:href="/static/images/icons/lta-icons.svg#close"></use></svg>Remove
                                            </button>
                                            <div class="u-stamp2 u-mb-1 u-fw-bold">DISCOUNT APPLIED</div>
                                            <div class="u-body1 u-text-grey-lta">We have applied your <span class="p-checkout-component__discount-code-percentage">20</span>% discount for code<span class="p-checkout-component__discount-code-text">SCOUT123</span></div>
                                        </div>
                                    </div>
                                    <div class="p-checkout-component__discount-code md:u-hstack">
                                        <div class="lta-text-input__wrapper p-checkout-component__discount-code-input md:u-mr-2">
                                            <p class="u-fw-bold">Discount code</p>
                                            <div class="lta-text-input--error discount-code-error u-hidden"></div>
                                            <input type="text" class="lta-text-input" id="discount-code-input" placeholder="" value="" name="discount-code-input" aria-label="Discount code (Optional)" data-call-from="custom" pattern="[a-zA-Z0-9]+">
                                        </div>
                                        <button type="submit" id="js-checkout-component__discount-code-btn" class="p-checkout-component__discount-code-apply-button lta-btn lta-btn--default lta-btn--primary u-mt-4 u-px-5">Apply</button>
                                    </div>
                                    <p class="p-checkout-component__discount-code-success u-hidden">Discount successfully applied</p>
                                    <div class="p-checkout-component__discount-code-timer"></div>
                                </div>`
                            : ''
                        }
                        
                        <div class="payment-methods u-py-5 u-border-bottom">
                            <label class="u-mb-1 u-block u-body2 u-text-grey-ui-mid">Payment Method</label>
                            <div class="saved-cards-details u-hidden">
                                <div class="saved-cards-list">
                                    <div class="lta-text-input--error"></div>
                                </div>
                                <div class="add-another-card u-mb-2">
                                    <button
                                        type="button"
                                        class="lta-btn lta-btn--lg lta-btn--link add-another-card--button u-text-lta-blue"
                                    >
                                        Or add another card to pay with
                                    </button>
                                </div>
                            </div>
                            <div class="payment-method-selector-wrapper md:u-px-3">
                                <div class="payment-method-card">
                                    <div id="flexRadioForm" class="lta-form-check u-py-2 u-px-4 u-border-bottom">
                                        <input
                                            class="lta-form-check-input"
                                            type="radio"
                                            name="payment-method"
                                            id="card-input"
                                            value="card"
                                            checked=""
                                            data-title="Title"
                                            data-description="DataDescription"
                                        />
                                        <label class="lta-form-check-label" for="card-input">Credit / Debit Card</label>
                                    </div>
                                    <div class="u-px-2 u-pt-2">
                                        <fieldset id="${CARD_FIELDSET_SELECTOR}" data-provider="lta_payment">
                                            <div id="card-number" class="lta-text-input__wrapper u-mb-3">
                                                <label for="card-number-element" class="lta-text-input__label">
                                                    Card Number
                                                </label>
                                                <div class="lta-text-input--error u-hidden"></div>
                                                <div class="icon-overlay-wrapper">
                                                    <div id="card-number-element" class="u-block"></div>
                                                    <div class="icon-overlay">
                                                        <svg
                                                            class="card-type-icon"
                                                            width="24px"
                                                            height="16px"
                                                            style="color: currentColor"
                                                            fill="currentColor"
                                                            alt="card-visa"
                                                            aria-hidden="true"
                                                            data-brand="visa"
                                                        >
                                                            <use
                                                            xlink:href="/static/images/icons/lta-icons.svg#card-visa"
                                                            ></use>
                                                        </svg>
                                                        <svg
                                                            class="card-type-icon"
                                                            width="24px"
                                                            height="16px"
                                                            style="color: currentColor"
                                                            fill="currentColor"
                                                            alt="card-mastercard"
                                                            aria-hidden="true"
                                                            data-brand="mastercard"
                                                        >
                                                            <use xlink:href="/static/images/icons/lta-icons.svg#card-mastercard"></use>
                                                        </svg>
                                                        <svg
                                                            class="card-type-icon"
                                                            width="24px"
                                                            height="16px"
                                                            style="color: currentColor"
                                                            fill="currentColor"
                                                            alt="card-amex"
                                                            aria-hidden="true"
                                                            data-brand="amex"
                                                        >
                                                            <use xlink:href="/static/images/icons/lta-icons.svg#card-amex"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="card-expiry" class="lta-text-input__wrapper u-mb-3">
                                                <label for="card-expiry-element" class="lta-text-input__label">Expiry Date</label>
                                                <div class="lta-text-input--error u-hidden"></div>
                                                <div id="card-expiry-element" class="u-block"></div>
                                            </div>
                                            <div id="card-cvc" class="lta-text-input__wrapper u-mb-3">
                                                <label for="card-cvc-element" class="lta-text-input__label">CVC</label>
                                                <div class="lta-text-input--error u-hidden"></div>
                                                <div class="icon-overlay-wrapper">
                                                    <div id="card-cvc-element" class="u-block"></div>
                                                    <div class="icon-overlay">
                                                        <img
                                                            alt="Card CVC location"
                                                            title=""
                                                            width="30px"
                                                            height="25px"
                                                            src="/static/images/icons/card-cvc.png"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="card-postalcode" class="lta-text-input__wrapper u-mb-3">
                                                <label
                                                    for="${CARD_BILLING_POSTCODE_SELECTOR}"
                                                    class="lta-text-input__label">
                                                        Billing Postcode
                                                </label>
                                                <div class="lta-text-input--error u-hidden">
                                                    Please enter a valid UK postcode
                                                </div>
                                                <input
                                                    type="text"
                                                    class="lta-text-input"
                                                    id="${CARD_BILLING_POSTCODE_SELECTOR}"
                                                    placeholder="Postcode"
                                                />
                                            </div>
                                        </fieldset>                                        
                                    </div>
                                </div>
                                <div class="payment-method-wallet">
                                    <div id="wallet-form" class="lta-form-check u-py-2 u-px-4 u-hidden">
                                        <input
                                            class="lta-form-check-input"
                                            type="radio"
                                            name="payment-method"
                                            id="wallet-input"
                                            value="wallet"
                                            data-title="Title"
                                            data-description="DataDescription"
                                        />
                                        <label class="lta-form-check-label" for="wallet-input">Wallet
                                        <span class="lta-form-check__label-instruction">Wallet Icon Placeholder</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="lta-checkout-component__summary-info u-mb-3 md:u-hidden u-mt-3">
                            ${rowData?.agreementText ?? ""}
                        </div>
                        <div class="lta-checkout-component__summary-button md:u-hidden u-mb-3">
                            <button type="submit" id="js-checkout-component__payment-btn-mobile" class="lta-btn lta-btn--default lta-btn--primary lta-btn--block">Pay now</button>
                        </div>
                    </form>
                </div>
                <div class="lta-checkout-component__summary u-bg-background-blue">
                    <div class="lta-checkout-component__summary-container">
                        <div class="lta-checkout-component__title u-w-100 md:u-hidden">${titleMarkup}</div>
                        <p class="lta-checkout-component__summary-title">${rowData?.count === 1 ? '1 child' : `${rowData.count} children`}</p>
                        <div class="lta-checkout-component__summary u-mb-3 u-w-100">
                            <div class="u-mb-2 u-fw-bold" style="
                                display: flex;
                                justify-content: space-between;
                            "> 
                                <p>Booking price</p>
                                <p class="lta-checkout-component__summary-price">£${rowData.total}</p>
                            </div>
                            <div class="discount-list"></div>
                        </div>
                        <hr class="u-mb-3"/>
                        <div class="lta-checkout-component__summary-info u-mb-3 u-hidden md:u-block">
                            ${rowData?.agreementText ?? ""}
                        </div>
                        <div class="lta-checkout-component__summary-button u-hidden md:u-flex">
                            <button type="submit" id="js-checkout-component__payment-btn" class="lta-btn lta-btn--default lta-btn--primary lta-btn--block">Pay now</button>
                        </div>
                    </div>
                </div>
                <div id="payment-request-button" classes="u-hidden" />
            </div>
        `;
    }

    renderTitle(title) {
        return title ? `<div class="lta-heading-title u-mb-5 sm:u-mb-3">${title}</div>` : '';
    }

    afterRender() {
        this.paymentMethodSelector = SelectorEngine.findOne('.js-lta-payment-checkout', this._element);
        this.cardFieldset = SelectorEngine.findOne(`#${CARD_FIELDSET_SELECTOR}`, this._element);
        this.paymentBtn = SelectorEngine.findOne('#js-checkout-component__payment-btn', this._element);
        this.paymentBtnMobile = SelectorEngine.findOne('#js-checkout-component__payment-btn-mobile', this._element);
        this.cardPostalCode = SelectorEngine.findOne(`#${CARD_BILLING_POSTCODE_SELECTOR}`, this._element);
        this.paymentContainer = SelectorEngine.findOne('.payment-methods', this._element);

        this.errorContainer = SelectorEngine.findOne('.p-checkout__error-container', this._element);
        this.errorElement = SelectorEngine.findOne('.lta-snackbar__label',  this.errorContainer);
        this.errorContainerBtn = SelectorEngine.findOne('.p-checkout__error-container-btn',  this.errorContainer);

        this.discountCodeContainer = SelectorEngine.findOne('.p-checkout-component__discount-code-container', this._element);

        if( this.discountCodeContainer) {
            this.discountCodeBtn = SelectorEngine.findOne('#js-checkout-component__discount-code-btn', this._element);
            this.discountCodeErrorContainer = SelectorEngine.findOne('.discount-code-error', this._element);
            this.discountCodeInputContainer = SelectorEngine.findOne('.p-checkout-component__discount-code-input', this._element);
            this.voucherCodeContainer = SelectorEngine.findOne('.discount-list', this._element);
            this.input = document.getElementById("discount-code-input");
            this.priceToPay = this.rowData.total;
            this.appliedCodes = [];
            this.discountTimer = null;
            this.initialTiming = this.rowData.discountTimer || 180;
            this.rowData.appliedCodes = null;
            this.rowData.promocodeType = null;
        }
        this.initEvents();
        if(this.paymentMethodSelectorInstance) {
            this.initiatePaymentCardFields();
        }
    }

    setErrorHandler(error) {
        this.errorContainer.classList.remove('u-hidden');
        this.errorElement.innerHTML = error;
    }

    initPayment() {
        try {
            this.initPaymentSelector();
            this.initiatePaymentCardFields();
        } catch(error) {
            console.error(error);
        }
    }

    paymentInProgressHandler() {
        this.togglePaymentButtons(true);
    }

    paymentCompletedHandler() {
        this.togglePaymentButtons(false);
    }

    initPaymentSelector() {
        if (this.paymentMethodSelector) {
            if (!this.paymentMethodSelectorInstance) {
                this.paymentMethodSelectorInstance = PaymentMethodSelector.getOrCreateInstance(this.paymentMethodSelector);
                this.paymentMethodSelectorInstance.onPaymentInProgress(this.paymentInProgressHandler.bind(this));
                this.paymentMethodSelectorInstance.onPaymentCompleted(this.paymentCompletedHandler.bind(this));
            }
        } else {
            throw new Error('Payment method selector not found');
            return;
        }
    }

    initiatePaymentCardFields() {
        if(this.cardFieldsetInstance) {
            this.cardFieldsetInstance?.destroy();
            delete this.cardFieldsetInstance;
        }
        if(this.cardFieldset) {
            this.cardFieldsetInstance = new PaymentCardFields(this.cardFieldset);
        }
    }

    initEvents() {
        if (this.paymentBtn) {
            EventHandler.on(this.paymentBtn, CLICK_EVENT, this.paymentHandler.bind(this));
        }
        if (this.paymentBtnMobile) {
            EventHandler.on(this.paymentBtnMobile, CLICK_EVENT, this.paymentHandler.bind(this));
        }
        if (this.discountCodeBtn) {
            EventHandler.on(this.discountCodeBtn, CLICK_EVENT, this.handleDiscountCode.bind(this));
        }

        EventHandler.on(this.errorContainerBtn, CLICK_EVENT, () => {
            this.error = null;
			this.errorContainer.classList.add("u-hidden");
		});

        if(this.discountCodeContainer) {
            this.voucherCodeContainer.addEventListener('click', (e) => {
                const btn = e.target.closest('.p-checkout-component__remove-discount-code-btn');
                if (!btn) return;

                const code = btn.dataset.code;
                this.addRemoveDiscount(code, "remove");
            });

            this.input.addEventListener("input", () => {
                this.removeDiscountError();
            });
        }
    }

    handleDiscountCode(event) {
        event.preventDefault();
        const code = this.input.value.trim().toUpperCase();

        const error = this.validateDiscountCode(code);
        if (error) return this.applyDiscountError(error);

        this.addRemoveDiscount(code, "apply");
    }

    validateDiscountCode(code) {
        if (!code) return this.rowData.discountError.noEmpty || "Please enter coupon code";

        if (this.appliedCodes.some(c => c.couponCode === code)) {
            return this.rowData.discountError.duplicate || "This coupon has already been applied";
        }

        if (this.appliedCodes.some(c => c.discountType.toUpperCase() === "PERCENT")) {
            return this.rowData.discountError.percentage || "	This coupon cannot be combined with other applied offers";
        }

        if (this.appliedCodes.length >= this.rowData.count) {
            return this.rowData.discountError.maxLimit || "You have reached the maximum number of coupons allowed for this order";
        }

        return null;
    }

    //use the same API for both add and remove api
    async addRemoveDiscount(code, action, options={}) {
        const { silent = false } = options; // Here silent is required as when the timer is expired we need to call remove api to remove all the coupons individually.

        const api = this.rowData.discountVocuherApi;
        const payload = this.buildDiscountPayload(code, action);
  
        try {
            if (!silent) startLoadingAnimation();

            const responseData = await Request.post(api, payload);

            if (!responseData?.success) {
                const message = responseData?.message || responseData?.error ||"Unable to apply coupon at the moment. Please Refresh and try again";

                if (!silent) this.applyDiscountError(message);
                    return;
                }
           if (!silent) {
                this.updateSummary(responseData);
                this.startDiscountTimer(action);
                this.removeDiscountError();
            }

            return responseData;

        } catch (error) {
            console.error("Discount API error:", error);
            if (!silent) {
                this.applyDiscountError(error?.message || "Unable to apply coupon at the moment. Please Refresh and try again");
            }
        }finally {
            if (!silent) stopLoadingAnimation();
        }
    }

    buildDiscountPayload(code, action) {
        return {
            action: action,
            contactId: this.rowData.contactId,
            appliedCoupon: code,
            originalTotal: this.rowData.total,
            priceToPay: this.priceToPay,
            items: [
                {
                    productId: this.rowData.productId,
                    quantity: this.rowData.count
                }
            ]
        };
    }

    startDiscountTimer(action) {
        const timerEl = SelectorEngine.findOne('.p-checkout-component__discount-code-timer', this._element);
        if (!this.appliedCodes || this.appliedCodes.length === 0) {
            if (this.discountTimer) {
                clearInterval(this.discountTimer);
                this.discountTimer = null;
            }
            if (timerEl) timerEl.textContent = "";
            return;
        }

        // clear existing timer
        if (this.discountTimer) {
            clearInterval(this.discountTimer);
        }

        if (action === "apply") {
            this.discountEndTime = Date.now() + (this.initialTiming * 1000);
        }

        const update = () => {
            const now = Date.now();
            const timeLeft = Math.max(0, Math.floor((this.discountEndTime - now) / 1000));

            this.updateTimerDisplay(timerEl, timeLeft);

            if (timeLeft <= 0) {
                clearInterval(this.discountTimer);
                this.discountTimer = null;
                timerEl.textContent = "Discount expired";
                this.handleDiscountExpiry();
            }
        };

        update();
        this.discountTimer = setInterval(update, 1000);
    }

    updateTimerDisplay(element, timeLeft) {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        element.classList.add('u-title3', 'u-mt-1', 'u-text-lta-blue')
        element.textContent = `Coupon expires in ${minutes}:${seconds.toString().padStart(2, '0')}`;
    }

    pauseDiscountTimer() { // we are pausing the discount time on click on pay now do that discount codes were not removed during the payment process.
        if (this.discountTimer) {
            clearInterval(this.discountTimer);
            this.discountTimer = null;
        }
    }

    async handleDiscountExpiry() {
        if (!this.appliedCodes || this.appliedCodes.length === 0) return;

        const coupons = [...this.appliedCodes];

        try {
            startLoadingAnimation();

            for (const coupon of coupons) {
                await this.addRemoveDiscount(
                    coupon.couponCode,
                    "expire",
                    { silent: true }
                );
            }

            this.removeAppliedCoupons();

            const originalPrice = this.rowData?.total;

            const discountList = SelectorEngine.findOne('.discount-list', this._element);
            if (discountList) {
                discountList.innerHTML = '';
            }

            const priceEl = SelectorEngine.findOne('.lta-checkout-component__summary-price-to-pay', this._element);
            if (priceEl) {
                priceEl.innerHTML = `
                    <p>Price to pay</p>
                    <p>£${originalPrice.toFixed(2)}</p>
                `;
            }

            if (originalPrice !== 0) {
                this.paymentContainer.classList.remove('u-hidden');
            } else {
                this.paymentContainer.classList.add('u-hidden');
            }

            const timerEl = SelectorEngine.findOne('.p-checkout-component__discount-code-timer', this._element);
            if (timerEl) timerEl.textContent = '';

            this.priceToPay = originalPrice;
            this.input.value = '';
            this.applyDiscountError("Your coupon session has expired. Please apply again");
        } catch (err) {
            console.error("Expiry removal failed:", err);
        } finally {
            stopLoadingAnimation();
        }
    }

    removeAppliedCoupons() {
        //Clear stored coupons
        this.appliedCodes = [];

        this.rowData.appliedCodes = null;
        this.rowData.promocodeType = null;
    }

    applyDiscountError(errorMessage) {
        this.discountCodeInputContainer.classList.add("p-checkout-component__discount-code-error");
        this.discountCodeErrorContainer.classList.remove("u-hidden");
        this.discountCodeErrorContainer.innerHTML = errorMessage;
        return;
    }
    
    removeDiscountError(errorMessage) {
        this.discountCodeInputContainer.classList.remove("p-checkout-component__discount-code-error");
        this.discountCodeErrorContainer.classList.add("u-hidden");
        this.discountCodeErrorContainer.innerHTML = errorMessage
    }

    updateSummary(data) {
        const container = SelectorEngine.findOne('.discount-list', this._element);
        this.input.value = ''; // Clearing the promocode from input field on success.

        // Clear previous discounts
        container.innerHTML = '';

        const fragment = document.createDocumentFragment();

        const hasCoupons = data?.appliedCoupons && data.appliedCoupons.length > 0;

        if(hasCoupons) {
            data.appliedCoupons.forEach(coupon => {
                const discountEl = document.createElement('div');
                discountEl.classList.add('discount-item', 'u-mb-2');

                discountEl.innerHTML = `
                <div class="discount-row">
                    <p class="u-fw-bold">Discount</p>
                    <p>-£${coupon.discount.toFixed(2)}</p>
                </div>
                <div class="discount-code u-body2 u-pb-05">
                    ${coupon.couponCode}
                </div>
                <button data-code="${coupon.couponCode}" type="button" class="lta-btn lta-btn--xs lta-btn--petite p-checkout-component__remove-discount-code-btn">✕  Remove discount</button>
                `;

                fragment.appendChild(discountEl);
            });

            const totalPriceEl = document.createElement('div');
            totalPriceEl.classList.add('u-fw-bold', 'lta-checkout-component__summary-price-to-pay');
            totalPriceEl.innerHTML = `
                <p>Price to pay</p>
                <p>£${data?.priceToPay?.toFixed(2)}</p>
            `;

            fragment.appendChild(totalPriceEl);
            container.appendChild(fragment);
        }
       

        this.updateAppliedCoupons(data);

        if(data.priceToPay === 0) {
            this.paymentContainer.classList.add('u-hidden');
        }else {
            this.paymentContainer.classList.remove('u-hidden');
        }

        // Update the basket object
        window.lta.lta_payment.basket.totalCost = data.priceToPay;
        // Update price to pay
        this.priceToPay = data.priceToPay;
    }

    updateAppliedCoupons(data) {
        // Store the applied coupons so that we can validate the user entering the same coupon code again
        this.appliedCodes = data.appliedCoupons.map(c => ({
            couponCode: c.couponCode.toUpperCase(),
            discountType: c.discountType // here we are storing the discount type if the type is Percentage user cannot apply any other coupons
        }));

        // we are storing the applied coupons as we need to send it as part of the submit api.
        this.rowData.appliedCodes = data.appliedCoupons.map(c => c.couponCode.toUpperCase()).join(',');
        this.rowData.promocodeType = data?.appliedCoupons[0]?.discountType;
    }

    async paymentHandler(event) {
        this.pauseDiscountTimer();

        if (this.priceToPay === 0) {
            try {
                const response = await this.data.onSuccess(null, this.rowData?.appliedCodes, this.rowData.promocodeType);
                if (!response || !(response.Success || response.success)) {
                    this.paymentErrorHandler(response?.ErrorMessage || "Something went wrong");
                    return;
                }
                return response;
            } catch (error) {
                console.log(error);
                this.paymentErrorHandler(error);
                return;
            }
        }
        this.togglePaymentButtons(true);
        event.preventDefault();
        this?.paymentMethodSelectorInstance?.cardPaymentAsync({
            name: this.data?.userDetails?.name,
            email: this.data?.userDetails?.email,
            cardElements: this.cardFieldsetInstance?.getElements()
        }, this.paymentSuccessHandler.bind(this), this.paymentErrorHandler.bind(this));
    }


    async paymentSuccessHandler(paymentIntentId, afterAuthentication) {
        this.value = { value: paymentIntentId, fieldName: this?.data.fieldName, };
        this.error = null;

        try {
            const response = await this.data.onSuccess(afterAuthentication, this.rowData?.appliedCodes, this.rowData.promocodeType);
            return response;

        } catch (error) {
            console.log("Something went wrong", error);
            this.paymentErrorHandler(error);
        }
    }

    paymentErrorHandler(error, options = {} ) {
        const { shouldRerender = false } = options;
        this.shouldRerenderOnError = shouldRerender;
        this.error = (typeof error === 'string' ? error : error?.message) || "Something went wrong";
        this.togglePaymentButtons(false);
        this.shouldRerenderOnError = false;
    }

    togglePaymentButtons(disabled) {
        this.paymentBtn.disabled = disabled;
        this.paymentBtnMobile.disabled = disabled;
    }

    validate() {
        return !!this.value?.value;
    }
}
export default CheckoutComponent;
